import {
  Component,
  OnInit,
  OnDestroy,
  EventEmitter,
  Output,
  Input,
  OnChanges,
  SimpleChanges,
  AfterViewInit,
} from '@angular/core';
import classification from 'src/app/data/constants/Classification.json';
import TypeOfRequisitions from 'src/app/data/constants/TypeOfRequisition.json';
import {
  Classification,
  DropDown,
  DropDownOptions,
  ExtendedKeycloakUser,
  UserInformation,
} from 'src/app/shared/models/app-models';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Observable, Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import {
  GeneralForm,
  MyPurchaseForm,
} from 'src/app/shared/models/app-models/MyPurchaseForm.model';
import { Store } from '@ngrx/store';
import { updateGeneralForm } from 'src/app/core/store/form.actions';
import { StoreDropdowns } from 'src/app/shared/models/app-models';
import { isEqual } from 'lodash';
import { AddExcoDocumentDialogComponent } from '../add-exco-document-dialog/add-exco-document-dialog.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ExcoBoardDocumentRecord } from '../../../shared/models/app-models/ExcoBoardDocument.model';
import { BaseTableColumn } from 'src/app/shared/models/app-models/BaseTableColumn.model';
import { BlanketPurchaseColumns, ExcoBoardColumns } from '../../shared/constants';
import { AddReferenceDialogComponent } from '../add-reference-dialog/add-reference-dialog.component';
import { BlanketPurchaseRecord } from '../../../shared/models/app-models/BlanketPurchaseDocument.model';
import { ExtendedReasonForNotUsingRFQ } from 'src/app/shared/models/app-models/ExtendedReasonForNotUsingRFQ.model';
import { PermissionsService } from 'src/app/core/services/permissions/permission.service';
import { SelectionModel } from '@angular/cdk/collections';
import { environment } from 'src/environments/environment';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { DocumentStatusToRemoveDIRP, DocumentSubStatusToRemoveDIRP } from 'src/app/shared/models/database-models/DocumentStatus.model';
import { AbilityField } from 'src/app/core/services/permissions/AppAbility';
@Component({
  selector: 'app-general',
  templateUrl: './basic-information.component.html',
  styleUrls: ['./basic-information.component.scss'],
})
export class BasicInformationComponent implements OnInit, OnDestroy, OnChanges, AfterViewInit {
  @Input() isReadOnly: boolean = false;
  @Input() purchaseType: string = '';
  @Output() basicInfo = new EventEmitter();
  form!: MyPurchaseForm;
  genform!: GeneralForm;
  classification: Classification[] = classification.classifications;
  excoBoardDocumentArray: ExcoBoardDocumentRecord[] = []
  blanketPurchaseDocumentArray: BlanketPurchaseRecord[] = []
  blanketPurchaseColumns: BaseTableColumn<BlanketPurchaseRecord>[] = BlanketPurchaseColumns
  basicForm!: FormGroup;
  roDropdownDetails: DropDown;
  users: ExtendedKeycloakUser[] = [];
  ROdropDown: DropDownOptions[] = [];
  approvedOptions: DropDownOptions[];
  blanketPurchaseTypeOptions: DropDownOptions[];
  areExcoBoardDocumentsAttachedOptions: DropDownOptions[];
  ROControl!: FormControl;
  InternalControl!: FormControl;
  ExternalControl!: FormControl;
  PurposeControl!: FormControl;
  PurchaseTitleControl!:FormControl;
  ApprovedControl!: FormControl;
  BlanketPurchaseTypeControl: FormControl = new FormControl({ id: '', value: '' });
  ExcoBoardControl!: FormControl;
  IsDIRPControl!: FormControl;
  ReasonForNotUsingRFQControl!: FormControl;
  RFQControl!: FormControl;
  TypeOfRequisitionControl!: FormControl;
  typeOfRequisitiondropDown: DropDownOptions[] = [];
  requisitionOthersControl!: FormControl;
  PermissibleReasonControl!: FormControl;
  permissibleReasondropDown: DropDownOptions[] = [];
  reasonForNotUsingRFQDropdown: (ExtendedReasonForNotUsingRFQ | Pick<ExtendedReasonForNotUsingRFQ, "id" | "value" | "Name">)[] = [];
  OtherPermissibleReasonsControl!: FormControl;
  store$: Observable<MyPurchaseForm>;
  destory$: Subject<boolean> = new Subject<boolean>();
  RODataLoaded: boolean = false;
  internalCheck: boolean = false;
  externalCheck: boolean = false;
  internalValue = '0';
  wordCount = 0;
  loggedInUser!: UserInformation;
  basicFromUpdated: boolean = true;
  tooltipApprovedOriginal = `For selection of Blanket myPurchase or offline Approval of Requirements (e.g. approved by Board or Division Committee). If the offline approval is not found in the list, please contact Purchasing.`;
  CE: string = "To be assigned";
  TenderDocumentNo: string = "To be assigned";
  permissionData$:Observable<any>
  excoBoardColumns: any = ExcoBoardColumns
  pageSizeOptions = [5, 10, 20, 50]; 
  rowSelection = new SelectionModel<ExcoBoardDocumentRecord>(true, []);
  referenceColumns = ExcoBoardColumns
  digitalOfficeEmail= environment.digitalOfficeEmailId;
  className:string='purchase-title-text-field';
  referenceDisplayedColumns = [
    'vSelect',
    ...this.referenceColumns.filter(column => column.columnDef !== 'Id')
    .map(c => c.columnDef),
    'action'
  ];
  constructor(
    private _fb: FormBuilder,
    public router: Router,
    private store: Store<{
      form: MyPurchaseForm;
      dp: StoreDropdowns;
      user: UserInformation;
    }>,
    private route: ActivatedRoute,
    public materialDialog: MatDialog,
    private dialogRef: MatDialogRef<DialogComponent>,
    private permissionService:PermissionsService
  ) {
    this.permissionData$ = permissionService.getService()
    this.store$ = this.store.select('form');
    this.classification = classification.classifications;
    console.log('==============', this.purchaseType);
    // constant values for basic information
    this.roDropdownDetails = {
      title: 'Requesting Officer*',
      assistive: 'This staff represented in this application.',
      Options: [],
    };

    this.approvedOptions = [
      {
        id: '1',
        value: 'Yes',
      },
      {
        id: '2',
        value: 'No',
      },
    ];
    this.areExcoBoardDocumentsAttachedOptions = [
      {
        id: '1',
        value: 'Yes',
      },
      {
        id: '2',
        value: 'No',
      },
    ];
    this.blanketPurchaseTypeOptions = [
      {
        id: '1',
        value: 'Any',
      },
      {
        id: '2',
        value: 'AOR + WOC',
      },
    ]
    this.basicForm = this._fb.group({
      RO: { id: '', value: '' },
      internal: [{ id: '', value: '' }, [Validators.required]],
      external: [{ id: '', value: '' }, [Validators.required]],
      preApproved: { id: '', value: '' },
      areExcoBoardDocumentsAttached: { id: '', value: '' },
      excoBoardDocumentArray: this.excoBoardDocumentArray,
      isDIRP: false,
      reasonForNotUsingRFQ: [{ id: '', value: '' }, [Validators.required]],
      blanketPurchaseType: { id: '', value: '' },
      blanketPurchaseDocumentArray: [],
      purpose: [{ id: '', value: '' }, [Validators.required]],
      typeOfRequisition: { id: '', value: '' },
      requisitionOthers: null,
      permissibleReason: { id: '', value: '' },
      otherPermissibleReasons: { id: '', value: null },
      purchaseTitle: null,
    });
    this.ROControl = this.basicForm.controls['RO'] as FormControl;
    this.InternalControl = this.basicForm.controls['internal'] as FormControl;
    this.ExternalControl = this.basicForm.controls['external'] as FormControl;
    this.PurposeControl = this.basicForm.controls['purpose'] as FormControl;
    this.PurchaseTitleControl = this.basicForm.controls['purchaseTitle'] as FormControl;
    this.PermissibleReasonControl = this.basicForm.controls['permissibleReason'] as FormControl;
    this.OtherPermissibleReasonsControl = this.basicForm.controls['otherPermissibleReasons'] as FormControl;
    this.ApprovedControl = this.basicForm.controls[
      'preApproved'
    ] as FormControl;

    this.ExcoBoardControl = this.basicForm.controls[
      'areExcoBoardDocumentsAttached'
    ] as FormControl;
    this.IsDIRPControl = this.basicForm.controls[
      'isDIRP'
    ] as FormControl;
    this.ReasonForNotUsingRFQControl = this.basicForm.controls['reasonForNotUsingRFQ'] as FormControl;
    this.TypeOfRequisitionControl = this.basicForm.controls[
      'typeOfRequisition'
    ] as FormControl;
    this.requisitionOthersControl = this.basicForm.controls['requisitionOthers'] as FormControl;
    this.purchaseType = this.route.snapshot.params['purchaseType'].split(
      ';'
    )[0] as string;
  }

  ngAfterViewInit(): void {
    if (this.ReasonForNotUsingRFQControl.value?.value && !this.ReasonForNotUsingRFQControl.dirty) {
      this.ReasonForNotUsingRFQControl.markAsDirty();
    }
  }
  
  async ngOnInit(): Promise<void> {
    this.store$
      .pipe(takeUntil(this.destory$))
      .subscribe((form: MyPurchaseForm) => {
        this.form = form;
        this.genform = form.generalForm as GeneralForm;
        if (form.CE) {
          this.CE = this.ROdropDown.find((user) => user.id == form.CE)?.value ?? "To be assigned";
        }

        if (form.TenderDocumentNumber) {
          this.TenderDocumentNo = form.TenderDocumentNumber;
        }
        this.updateFormControls();
      });

    // getting current user
    this.store
      .select('user')
      .pipe(takeUntil(this.destory$))
      .subscribe((user: UserInformation) => {
        this.loggedInUser = user;
        if (!this.ROControl.value.id)
          this.ROControl.setValue({
            id: this.loggedInUser.userName,
            value: this.loggedInUser.fullName,
          });
      });
    // getting kc user list from store
    this.store
      .select('dp')
      .pipe(takeUntil(this.destory$))
      .subscribe((dp: StoreDropdowns) => {
        this.ROdropDown = dp.UserList;
        this.RODataLoaded = true;
        this.typeOfRequisitiondropDown = TypeOfRequisitions.typeOfRequisitions;
        this.permissibleReasondropDown = dp.PermissibleReason;
        this.reasonForNotUsingRFQDropdown = [...dp.ReasonForNotUsingRFQ]; 
      });

    // filtering and disabling external control based on the values chosen in internal classification
    this.InternalControl.valueChanges.subscribe((selectedInternal) => {
      this.internalValue = selectedInternal['id'];
      if (this.ExternalControl?.value['id'] > selectedInternal['id']) {
        // this function sets the external value when internal is higher than external.
        this.ExternalControl.setValue(selectedInternal);
      }
    });

    // updating word count for purpose
    this.PurposeControl?.valueChanges.subscribe((typed) => {
      this.wordCount = typed ? typed.length : 0;
    });

    this.PurchaseTitleControl?.valueChanges.subscribe((typed) => {
      this.wordCount = typed ? typed.length : 0;
    });

    this.ReasonForNotUsingRFQControl.valueChanges.subscribe((selectedOption) => {
      if (selectedOption?.value) {
        this.ReasonForNotUsingRFQControl.markAsDirty();
      } else {
        this.ReasonForNotUsingRFQControl.markAsPristine();
      }
    })

    // update the store accordingly if there's changes
    this.basicForm.valueChanges.subscribe((value: GeneralForm) => {
      if (
        isEqual(value, this.genform) ||
        typeof this.ROControl.value == 'string'
      )
        return;
      this.updateForm();
    });
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes["isReadOnly"]) {
      /*if (changes["isReadOnly"].currentValue == true) {
        this.basicForm.disable();
      }
      else {
        this.basicForm.enable();
      }*/
    }
  }
  ngOnDestroy(): void {
    this.destory$.next(true);
    this.destory$.unsubscribe();
  }

   // checkbox toggling
   onCheckboxChange($event: any, row: any): void {
    ($event) ? this.rowSelection.toggle(row) : null;
  }
  
  // function to check if all checkboxes are checked
  isAllVSelected() {
    const numSelected = this.rowSelection.selected.length;
    const numRows = this.excoBoardDocumentArray.length;
    return numSelected === numRows;
  }

  isVselected() {
    if (this.rowSelection.selected.length !== 0) return true;
    return false;
  }
  masterVToggle() {
    if (this.isAllVSelected()) {
      this.rowSelection.clear();
    } else {
      this.excoBoardDocumentArray.forEach((row) =>
        this.rowSelection.select(row)
      );
    }
  }

  openDialog(record: any) {
    console.log("@@@ openDialog ",record);
    console.log(this.excoBoardDocumentArray.length)
    this.dialogRef = this.materialDialog.open(DialogComponent, {
      // height: '200px',
      // width: '450px',
      panelClass: 'item-vendor-dialog',
      hasBackdrop: true,
      data: {
        headerTitle: 'Discard item record?',
        contentMsg: 'This action cannot be undone.',
        btnNameOne: 'Discard',
        btnNameTwo: 'Cancel',
        click: () => {
          this.deleteExcoBoardDocumentRecord(record);
          this.dialogRef.close();
        },
        clickTwo: () => {
          this.dialogRef.close();

        }
      },
    });
  }

  // update store
  updateForm() {
    this.store.dispatch(
      updateGeneralForm({ form: { ...this.basicForm.value } })
    );
  }

  // set string to null for non others
  OnTypeOfRequisitionChange($event: any) {
    if ($event?.id != "PR9999") {
      this.requisitionOthersControl.setValue(null);
    }
  }

  // updating form controls values in this component
  updateFormControls() {
    let reasonForNotUsingRFQOption;
    if (this.genform.reasonForNotUsingRFQ?.value) {
      reasonForNotUsingRFQOption = this.reasonForNotUsingRFQDropdown.find(
        (option) => option.value === this.genform.reasonForNotUsingRFQ.value
      );
    }

    this.basicForm.setValue({
      ...this.genform,
      reasonForNotUsingRFQ: reasonForNotUsingRFQOption ?? this.genform.reasonForNotUsingRFQ ?? { id: '', value: '' },
    });
    if (!this.ROControl.value.id) {
      this.ROControl.setValue({
        id: this.loggedInUser?.userName,
        value: this.loggedInUser?.fullName,
      });
    }

    if (this.genform.excoBoardDocumentArray)
      this.excoBoardDocumentArray = this.genform.excoBoardDocumentArray
  }

  openExcoDialog() {
    let dialogRef = this.materialDialog.open(AddExcoDocumentDialogComponent, {
      // height: '700px',
      data: this.excoBoardDocumentArray
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        const records: ExcoBoardDocumentRecord[] = result
        const updatedRecords = this.returnUpdatedExcoBoardDocumentRecord(records)
        this.excoBoardDocumentArray = updatedRecords ?? [];
        this.basicForm.controls['excoBoardDocumentArray'].setValue(this.excoBoardDocumentArray)
        console.log(this.basicForm.value)
      }
    });
  }
  returnUpdatedExcoBoardDocumentRecord(selectedRecords: ExcoBoardDocumentRecord[]) {
    const newArray: ExcoBoardDocumentRecord[] = []
    for (const record of this.excoBoardDocumentArray) {
      let selectedRecord = selectedRecords.find((x) => x.id == record.id);
      // if (record.EXCOApprovalID) {
        if (record.IsDeleted && !selectedRecord) {
          const { IsDeleted, ...remainingData } = record
          let newRecord = { IsDeleted: true, ...remainingData }
          newArray.push(newRecord)
        }
        else {
          const { IsDeleted, ...remainingData } = record
          let newRecord = { IsDeleted: false, ...remainingData }
          newArray.push(newRecord)
        }
      // }
    }
    selectedRecords.forEach(selected => {
      let doesRecordExist = newArray.find((x) => x.id == selected.id)
      if (!doesRecordExist) newArray.push(selected)
    })
    return newArray
  }

  deleteExcoBoardDocumentRecord(deletedRecords : any) {
    const newArray: ExcoBoardDocumentRecord[] = []
    
    for (const record of this.excoBoardDocumentArray) {      
      if (deletedRecords.id == record.id || record.IsDeleted == true) {
        const { IsDeleted, ...remainingData } = record
        let newRecord = { IsDeleted: true, ...remainingData }
        newArray.push(newRecord)
      }
      else {
        const { IsDeleted, ...remainingData } = record
        let newRecord = { IsDeleted: false, ...remainingData }
        newArray.push(newRecord)
      }
    }
    this.excoBoardDocumentArray = newArray
    this.basicForm.controls['excoBoardDocumentArray'].setValue(this.excoBoardDocumentArray)
  }

  openBlanketPurchaseDialog(blanketPurchaseType: string) {
    //openDialog() {
    if (blanketPurchaseType !== 'any' && blanketPurchaseType !== 'aor+woc') return
    let dialogRef = this.materialDialog.open(AddReferenceDialogComponent, {
      // width: '80%',
      // height: '80%',
      data: {
        blanketPurchaseType: blanketPurchaseType,
        selectedRecordsArray: this.blanketPurchaseDocumentArray
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.isArray) {
        const record: BlanketPurchaseRecord[] = result
        this.blanketPurchaseDocumentArray = record
      }
    });
  }
  onExcoBoardValChange(event: any) {
    console.log(event)
    this.ExcoBoardControl.setValue(event.value)
    console.log(this.ExcoBoardControl.getRawValue())
    if (event.value.value == 'no') {
      const updatedArray: ExcoBoardDocumentRecord[] = []
      this.excoBoardDocumentArray.forEach((record) => {
        if (record.EXCOApprovalID) {
          let x: ExcoBoardDocumentRecord = { ...record }
          x.IsDeleted = true;
          updatedArray.push(x)
        }
      })
      this.excoBoardDocumentArray = updatedArray
      this.basicForm.controls['excoBoardDocumentArray'].setValue(this.excoBoardDocumentArray)
    }
  }
  onIsDIRPValChange(event: any) {
    this.IsDIRPControl.setValue(event.value)
    this.basicForm.controls['isDIRP'].setValue(event.value)
  }
  onPreapprovedValChange(event: any) {
    console.log(event)
    this.ApprovedControl.setValue(event.value)
    if (event.value.value == 'no') {
      this.blanketPurchaseDocumentArray = []
      this.basicForm.controls['blanketPurchaseDocumentArray'].setValue(this.blanketPurchaseDocumentArray)
    }
  }
  onBlanketTypeValChange(event: any) {
    console.log(event)
    if (event.value) this.BlanketPurchaseTypeControl.setValue(event.value)
    this.basicForm.controls['blanketPurchaseType'].setValue(event.value)
  }
  isString(value: any) {
    const htmlRegex = /<([a-z]+)(?![^>]*\/>)[^>]*>/
    const isHTML = htmlRegex.test(value)
    return (!isHTML)
  }

  // TODO: remove after DIRP is deprecated
  public get DocumentStatusToRemoveDIRP(): typeof DocumentStatusToRemoveDIRP {
    return DocumentStatusToRemoveDIRP;
  }
  // TODO: remove after DIRP is deprecated
  public get DocumentSubStatusToRemoveDIRP(): typeof DocumentSubStatusToRemoveDIRP {
    return DocumentSubStatusToRemoveDIRP;
  }

  public get AbilityField(): typeof AbilityField {
    return AbilityField
  }
}
